import * as z from 'zod'
import { TimezoneCode } from '~/shared/config/enums'
import {
  dateSchema,
  enumOptionSchema,
  stringRequiredScheme,
} from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributeSchema = z.object({
  name: stringRequiredScheme,
  timezone: enumOptionSchema(TimezoneCode),
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type RegionAttributes = z.infer<typeof attributeSchema>

export class Region extends ApiModel<typeof schema, RegionAttributes> {
  static jsonApiType = 'regions'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }
  getTimezone(): TimezoneCode {
    return this.getAttribute('timezone')
  }

  getOption(): { id: UniqueId; label: string } {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getName(),
    }
  }

  static async fetchOptions(search: string, regionId?: UniqueId) {
    if (regionId) {
      const response = await Region.find(regionId)
      const region = response.getData() as Region
      return [region?.getOption()]
    }

    const response = await Region.where('name', search).get(1)
    return response.getData().map((o) => o.getOption())
  }

  static async fetchOptionsByExclude(search: string, excludeRegions?: string) {
    let builder = Region.where('name', search)

    if (excludeRegions) {
      builder = builder.where('exclude', excludeRegions)
    }

    const response = await builder.get(1)

    return response.getData().map((o) => o.getOption())
  }
}
